import axios from '@/apis/axios';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';
import { SHAREHOLDER } from '@/constants/config';

class User 
{
    static async all() 
    {
        const response = await axios.get('api/admin/users');

        return response.data; 
    }
    
    static async switchUser(userId)
    {
        const response = await axios.post('api/admin/switch-user', {
            userId
        });

        return response.data; 
    }

    static async getCurrentUser()
    {
        const response = await axios.get('api/user');

        return response.data;
    }

    static async getByNRIC(nric, type = SHAREHOLDER.TYPE.INDIVIDUAL )
    {
        const response = await axios.get(`api/admin/users/nric/${nric}?shareholder_type=${type}`);

        return response.data.data;
    }

    static async updateInfo(data) {
        const response = await axios.put('api/user-info', transformObjectValuesToUpperCase(data));

        return response.data;
    }

    static async forgotPassword(email) {
        const response = await axios.post(`/forgot-password?email=${email}`);

        return response.data;
    }

    static async resetPassword(data) {
        const response = await axios.post('/reset-password', data);

        return response.data;
    }

    static async setPassword(email) {
        const response = await axios.post(`/api/set-password?email=${email}`);

        return response.data;
    }
    
    static async changePassword(data) {
        const response = await axios.put('api/user-password', data);

        return response.data;
    }

    static async updateAvatar(data) {
        const response = await axios.post('api/user-avatar', data);

        return response.data;
    }

    static async updateEmailByAdmin(data) {
        const response = await axios.post('api/admin/update-email-by-admin', data);

        return response.data;
    }

    static async getTokenStatus(token, email) {
        const response = await axios.get(`api/reset-password-token-status/${token}/${email}`);

        return response.data;
    }

    static async getCompanies(userId) {
        const response = await axios.get(`api/admin/${userId}/companies`);

        return response.data;
    }
    
    static async emailChangeAbleUserCompaniesIds() {
        const response = await axios.get('api/email-changeable-companies-ids');

        return response.data.data;
    }

    static async getEmailChangeAbleUserCompaniesIdsByUserId(userId) {
        const response = await axios.get(`api/${userId}/email-changeable-companies-ids`);

        return response.data.data;
    }

}
export default User;